var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-box-center"},_vm._l((_vm.toasts),function(toast){return _c('ns-toast',_vm._b({key:toast.id},'ns-toast',toast,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }